import React from "react";
import Header from "../component/Header/Header";
import Product from "../component/Product/Product";
import Footer from "../component/Footer/Footer";

const Edit = () => {
  return (
    <div>
      <Header />
      <Product top={"글 수정"} />
      <Footer />
    </div>
  );
};
//
export default Edit;
